import { apiService } from 'adapters/apiService';
import { HeaderData } from 'adapters/types';
import { validateCompanyAndStore } from 'adapters/utils';
import {
  ReconciliationReportDataType,
  PaymentStatusUpdateResponseDataType,
  PaymentStatusUpdateDataType,
  VoidPaymentRequestDataType,
  VoidPaymentStatusResponseDataType
} from 'pages/ReconciliationReportPage/types';
import { METHOD, PATHS } from '../constants';

export const fetchReconciliationReport = async (
  statuses: string,
  companyId: string,
  storeId: string,
  headers: HeaderData
): Promise<ReconciliationReportDataType[]> => {
  const qsObject = { statuses: statuses || undefined };
  validateCompanyAndStore(companyId, storeId);
  const response = await apiService({
    url: PATHS.getAccountingVirtualCardPayment(),
    method: METHOD.GET,
    qsObject,
    headers: { ...headers, 'x-store-id': storeId }
  });
  if (response?.ok)
    return response.json() as Promise<ReconciliationReportDataType[]>;
  throw new Error(response.statusText);
};

export const updateReconciliationPaymentStatus = async (
  reqObj: PaymentStatusUpdateDataType,
  headers: HeaderData,
  storeId: string
): Promise<PaymentStatusUpdateResponseDataType> => {
  const response = await apiService({
    url: PATHS.getAccountingVirtualCardPaymentStatus(),
    method: METHOD.PUT,
    reqObj,
    headers: { ...headers, 'x-store-id': storeId }
  });
  if (response?.ok)
    return response.json() as Promise<PaymentStatusUpdateResponseDataType>;
  throw new Error(response.statusText);
};

export const voidReconciliationPayment = async (
  headers: HeaderData,
  companyId: string,
  storeId: string,
  reqPayload: VoidPaymentRequestDataType
): Promise<VoidPaymentStatusResponseDataType> => {
  validateCompanyAndStore(companyId, storeId);
  const response = await apiService({
    url: PATHS.getAccountingVirtualCardPaymentVoid(),
    method: METHOD.PUT,
    reqObj: reqPayload,
    headers: { ...headers, 'x-store-id': storeId }
  });
  return response.json() as Promise<VoidPaymentStatusResponseDataType>;
};
